<template>
    <div class="modal ver2" id="winningRegistration_popup" :class="{ show: props.show }">
        <div class="modal_box">
            <div class="modal_head inner">
                <div class="h_left"></div>
                <div class="h_title">당첨번호 입력</div>
                <div class="h_right">
                    <button type="button" class="btn clear_btn close_btn" @click="closeModal"></button>
                </div>
            </div>
            <div class="modal_body inner">
                <div class="winning_box">
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number1 < 10, 'color2': number1 >= 10 && number1 < 20, 'color3': number1 >= 20 && number1 < 30, 'color4': number1 >= 30 && number1 < 40, 'color5': number1 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number1 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number1">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number2 < 10, 'color2': number2 >= 10 && number2 < 20, 'color3': number2 >= 20 && number2 < 30, 'color4': number2 >= 30 && number2 < 40, 'color5': number2 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number2 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number2">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number3 < 10, 'color2': number3 >= 10 && number3 < 20, 'color3': number3 >= 20 && number3 < 30, 'color4': number3 >= 30 && number3 < 40, 'color5': number3 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number3 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number3">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number4 < 10, 'color2': number4 >= 10 && number4 < 20, 'color3': number4 >= 20 && number4 < 30, 'color4': number4 >= 30 && number4 < 40, 'color5': number4 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number4 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number4">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number5 < 10, 'color2': number5 >= 10 && number5 < 20, 'color3': number5 >= 20 && number5 < 30, 'color4': number5 >= 30 && number5 < 40, 'color5': number5 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number5 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number5">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': number6 < 10, 'color2': number6 >= 10 && number6 < 20, 'color3': number6 >= 20 && number6 < 30, 'color4': number6 >= 30 && number6 < 40, 'color5': number6 >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ number6 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="number6">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                    <div class="winning_plus"></div>
                    <div class="winning_itembox">
                        <div class="winning_item">
                            <div class="winning_ball"
                                :class="{ 'color1': bonus < 10, 'color2': bonus >= 10 && bonus < 20, 'color3': bonus >= 20 && bonus < 30, 'color4': bonus >= 30 && bonus < 40, 'color5': bonus >= 40 }">
                                <div class="numbox">
                                    <span class="num">{{ bonus }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="select_box">
                            <select class="select" v-model="bonus">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                                <option value="32">32</option>
                                <option value="33">33</option>
                                <option value="34">34</option>
                                <option value="35">35</option>
                                <option value="36">36</option>
                                <option value="37">37</option>
                                <option value="38">38</option>
                                <option value="39">39</option>
                                <option value="40">40</option>
                                <option value="41">41</option>
                                <option value="42">42</option>
                                <option value="43">43</option>
                                <option value="44">44</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form_box">
                    <div class="input_box wid50">
                        <label for="mem_account" class="label_text">1등 당첨자 수</label>
                        <input type="text" id="mem_account" class="input_text" v-model="first_count">
                    </div>
                    <div class="input_box date wid50">
                        <label for="mem_account" class="label_text">2차 당첨자 수</label>
                        <input type="text" id="mem_date" class="input_text" v-model="second_count">
                    </div>
                </div>
                <div class="form_box">
                    <div class="input_box wid50">
                        <label for="mem_account" class="label_text">3등 당첨자 수</label>
                        <input type="text" id="mem_account" class="input_text" v-model="third_count">
                    </div>
                    <div class="input_box date wid50">
                        <label for="mem_account" class="label_text">회차</label>
                        <input type="text" id="mem_date" class="input_text" v-model="round" v-if="!props.isCorrect">
                        <input type="text" id="mem_date" class="input_text" v-model="round" v-else disabled>
                    </div>
                </div>
                <div class="form_box">
                    <div class="input_box wid50">
                        <label for="mem_account" class="label_text">추첨일</label>
                        <VueDatePicker :enable-time-picker="false" :clearable="false" :teleport="true" v-model="date" />
                    </div>

                </div>
            </div>
            <div class="modal_foot" v-if="!props.isCorrect">
                <button type="button" class="btn" @click="reqInsertWinning">등록</button>
            </div>
            <div class="modal_foot" v-else>
                <button type="button" class="btn" @click="reqUpdateWinning">수정</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, defineEmits, watch, ref } from "vue";
import { insert_winning, updateWinning } from "@/api";
import { useStore } from "vuex";
const store = useStore();

const props = defineProps({
    show: Boolean,
    isCorrect: Boolean,
    data: Object
});
const number1 = ref(0);
const number2 = ref(0);
const number3 = ref(0);
const number4 = ref(0);
const number5 = ref(0);
const number6 = ref(0);
const bonus = ref(0);
const date = ref('');

watch(() => props.data.num_1, (newData) => {

    number1.value = newData;
});

watch(() => props.data.num_2, (newData) => {

    number2.value = newData;
});

watch(() => props.data.num_3, (newData) => {

    number3.value = newData;
});

watch(() => props.data.num_4, (newData) => {

    number4.value = newData;
});

watch(() => props.data.num_5, (newData) => {

    number5.value = newData;
});

watch(() => props.data.num_6, (newData) => {

    number6.value = newData;
});

watch(() => props.data.bonus_num, (newData) => {

    bonus.value = newData;
});

watch(() => props.data.draw_date, (newDate) => {
    date.value = newDate;
});

const first_count = ref(0);
const second_count = ref(0);
const third_count = ref(0);
const round = ref(0);

watch(() => props.data.first_winning, (newData) => {
    first_count.value = newData;
});

watch(() => props.data.second_winning, (newData) => {
    second_count.value = newData;
});

watch(() => props.data.third_winning, (newData) => {
    third_count.value = newData;
});

watch(() => props.data.round, (newData) => {
    round.value = newData;
});

// const wid = computed(() => props.data.wid);

const emit = defineEmits(["modalClose"]);
const closeModal = () => {
    emit('modalClose');
}
const reqInsertWinning = async () => {
    if (number1.value === 0 || number2.value === 0 || number3.value === 0 || number4.value === 0 || number5.value === 0 || number6.value === 0 || bonus.value === 0 || round.value === 0 || date.value === '') {
        store.commit('setInfoModal', '모든 항목을 입력해주세요.');
        return;
    } else {
        const checkNumber = [number1.value, number2.value, number3.value, number4.value, number5.value, number6.value, bonus.value];
        const uniqueNumbers = new Set(checkNumber);

        if (uniqueNumbers.size !== checkNumber.length) {
            store.commit('setInfoModal', '중복된 숫자가 있습니다. 다른 숫자를 선택해주세요.');
            return;
        }

        const numbers = [number1.value, number2.value, number3.value, number4.value, number5.value, number6.value];
        numbers.sort((a, b) => a - b);

        // 정렬된 숫자들을 다시 변수에 대입
        number1.value = numbers[0];
        number2.value = numbers[1];
        number3.value = numbers[2];
        number4.value = numbers[3];
        number5.value = numbers[4];
        number6.value = numbers[5];
        const data = {
            number1: parseInt(number1.value),
            number2: parseInt(number2.value),
            number3: parseInt(number3.value),
            number4: parseInt(number4.value),
            number5: parseInt(number5.value),
            number6: parseInt(number6.value),
            bonus: parseInt(bonus.value),
            first_count: first_count.value,
            second_count: second_count.value,
            third_count: third_count.value,
            round: round.value,
            date: date.value,
        }
        const res = await insert_winning(data);
        if (res.status == 200) {
            store.commit('setRefreshModal', '등록되었습니다.');
        } else {
            store.commit('setInfoModal', '등록 실패');
        }
    }
}

const reqUpdateWinning = async () => {
    if (number1.value === 0 || number2.value === 0 || number3.value === 0 || number4.value === 0 || number5.value === 0 || number6.value === 0 || bonus.value === 0 || round.value === 0 || date.value === '') {
        store.commit('setInfoModal', '모든 항목을 입력해주세요.');
        return;
    } else {
        const checkNumber = [number1.value, number2.value, number3.value, number4.value, number5.value, number6.value, bonus.value];
        const uniqueNumbers = new Set(checkNumber);

        if (uniqueNumbers.size !== checkNumber.length) {
            store.commit('setInfoModal', '중복된 숫자가 있습니다. 다른 숫자를 선택해주세요.');
            return;
        }

        const numbers = [number1.value, number2.value, number3.value, number4.value, number5.value, number6.value];
        numbers.sort((a, b) => a - b);

        // 정렬된 숫자들을 다시 변수에 대입
        number1.value = numbers[0];
        number2.value = numbers[1];
        number3.value = numbers[2];
        number4.value = numbers[3];
        number5.value = numbers[4];
        number6.value = numbers[5];
        const data = {
            number1: parseInt(number1.value),
            number2: parseInt(number2.value),
            number3: parseInt(number3.value),
            number4: parseInt(number4.value),
            number5: parseInt(number5.value),
            number6: parseInt(number6.value),
            bonus: parseInt(bonus.value),
            first_count: first_count.value,
            second_count: second_count.value,
            third_count: third_count.value,
            round: round.value,
            date: date.value,
            wid: props.data.wid,
        }
        const res = await updateWinning(data);
        if (res.status == 200) {
            store.commit('setRefreshModal', '수정 되었습니다.');
        } else {
            store.commit('setInfoModal', '수정 실패');
        }
    }
}
</script>

<style scoped>
.modal_box {
    max-width: 1000px !important;
}
.form_box {
    flex-direction: row !important;
    
}
</style>